"use client";

import { cn } from "@heroui/theme";
import { Icon } from "@iconify/react";
import React from "react";

interface Props {
  className?: string;
}
const JobAlert = ({ className }: Props) => {
  return (
    <div
      className={cn("relative w-full max-w-xl flex justify-center", className)}
    >
      <div className=" p-3 rounded-2xl bg-white/70 dark:bg-foreground-50/40 backdrop-blur-[3px] w-[274px] h-[96px] absolute top-8" />
      <div className=" p-3 rounded-2xl bg-white/70 dark:bg-foreground-50/50 backdrop-blur-[3px] w-[290px] absolute top-6 h-[96px]" />

      <div className=" p-3 rounded-2xl bg-white/70 dark:bg-foreground-50/60 backdrop-blur-[3px] w-[306px]">
        <div className="text-[#1FC16B] dark:text-primary-400 text-[11px] font-normal leading-3 tracking-[0.22px] uppercase p-2 bg-[#E0FAEC] dark:bg-primary-50 rounded-[32px] mb-2 inline-flex items-center justify-center">
          JOB POST
        </div>

        <div className="text-black dark:text-foreground-950 font-normal text-base leading-6 tracking-[-0.176px]">
          Jnr Software engineer
        </div>

        <div className="flex items-center text-foreground-700 dark:text-foreground-600 font-normal text-xs leading-4">
          <span>TechNova Ltd.</span>
          <Icon className="text-2xl" icon="mdi:dot" />
          <span>$450K/year</span>
          <Icon className="text-2xl" icon="mdi:dot" />
          <span>Remote</span>
        </div>
      </div>
    </div>
  );
};

export default JobAlert;
